import { helpers } from 'vuelidate/lib/validators'
import moment from 'moment'
export const alpha = helpers.regex('regex', /^[a-zA-ZñÑáéíóúÁÉÍÓÚäëöüÄËÖÜ. -]*$/)
export const alpha1 = helpers.regex('regex', /^[0-9A-Za-zñÑáéíóúÁÉÍÓÚ¡!¿?@#$%()=+-€/., ]*$/)
export const alpha2 = helpers.regex('regrex', /^[0-9#$%()=+-/., ]*$/)
export const email = helpers.regex('regex', /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/)
export const numero = helpers.regex('regex', /^[0-9]{8}$/)
export const alpha3 = helpers.regex('regex', /^(?!^0+$)[a-zA-Z0-9-]{5,15}$/)
export const isDate = (value) => moment(value, 'DD/MM/YYYY', true).isValid()

export const valDoc = (value, vm) => {

    if(vm.docIdentidad == "DNI"){
      return numero(value)
    }else{
      return alpha3(value)
    }
    //return vm.numberPersons >= 1;
};